import { render, staticRenderFns } from "./goodsDetails.vue?vue&type=template&id=bca57416&scoped=true&"
import script from "./goodsDetails.vue?vue&type=script&lang=ts&"
export * from "./goodsDetails.vue?vue&type=script&lang=ts&"
import style0 from "./goodsDetails.vue?vue&type=style&index=0&id=bca57416&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca57416",
  null
  
)

export default component.exports